import { useMemo } from 'react';

const useGenerateId = () => {
    return useMemo(() => `_${Math.random().toString(36).substring(2, 9)}`, []);
};

export default useGenerateId;
